// extracted by mini-css-extract-plugin
module.exports = {"text":"logo-module--text--3K_P0","textItem":"logo-module--textItem--2glPu"};